/**
 * Auswahlleiste unter dem Raster (Board „Vertrieb“): was gewählt ist, die Kurzwege der Auswahl und
 * „Werte setzen“ – das führt mit der Auswahl in den Monat des Apartments.
 */
import { nightsLabel, rangesLabel } from './calendarFormat';
import { totalNights, type SelectedRange } from './rangeSelectionModel';

interface Props {
  apartmentName: string;
  ranges: readonly SelectedRange[];
  onSetValues: () => void;
  onClear: () => void;
}

export function SelectionBar({ apartmentName, ranges, onSetValues, onClear }: Props) {
  if (ranges.length === 0) return null;
  return (
    <div
      role="region"
      aria-label="Auswahl"
      className="bg-ink sticky bottom-0 z-40 flex flex-wrap items-center gap-3 px-[18px] py-3.5 text-white"
    >
      <span className="flex min-w-0 grow flex-col">
        <span className="text-[15px] font-bold">
          {apartmentName}: {nightsLabel(totalNights(ranges))} in {rangesLabel(ranges.length)}
        </span>
        <span className="text-on-forest-soft text-xs">
          Strg-Klick: weiterer Zeitraum · Umschalt-Klick: verlängern · bis zu 50 Zeiträume
        </span>
      </span>
      <button
        type="button"
        onClick={onSetValues}
        className="rounded-pill text-ink h-11 bg-white px-[18px] text-sm font-bold hover:bg-white/90"
      >
        Werte setzen →
      </button>
      <button
        type="button"
        onClick={onClear}
        className="rounded-pill h-11 px-3.5 text-sm font-bold text-white hover:bg-white/10"
      >
        Auswahl verwerfen
      </button>
    </div>
  );
}
